import { chain, map } from 'fp-ts/lib/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import { listCodec } from './codec';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  decode,
  fetchApi,
  setQuery,
} from '../..';
import { encodeUpcomingQuery, UpcomingQuery } from './query';
import { resourceBulkDelete } from '@/services/api/resources/bulkDelete';

const baseUrl = '/v2/inspections/upcoming';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const list = (query: UpcomingQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeUpcomingQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const remove = (id: number) => pipe(
  id,
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const bulkDelete = (records: number[]) => resourceBulkDelete(records, baseUrl);
